import './styles';
import BadgeOutlinedIcon from '@mui/icons-material/BadgeOutlined';
import Diversity1Icon from '@mui/icons-material/Diversity1';
import {Box, Typography} from '@mui/material';
import {useTranslation} from 'react-i18next';
import {useNavigate} from 'react-router';

import {AppButton, ButtonContainer} from '@/app/shared-components';
import {IMAGES} from '@/constants/images';
import {LINKS} from '@/constants/LinksConstants';
import useWindowSize from '@/hooks/WindowSize/WindowSize';

import {useViewModelProvider, ViewModelProvider} from './ViewModelContext';

const CreateJourneyContent = () => {
  const {trackSelectOnboardingKidFinancialLiteracy} = useViewModelProvider();

  const navigate = useNavigate();
  const {isMobile} = useWindowSize();
  const {t} = useTranslation();
  return (
    <Box className="create-journey-page-container">
      <img
        src={`/assets/images/etc/journey_card_${isMobile ? 'mobile' : 'desktop'}.webp`}
        alt="MoCardInTheCity"
        style={{
          width: '100%',
          height: isMobile ? '100%' : '159px',
        }}
      />
      <Box className="create-journey-content-container">
        <Box className="create-journey-title-container">
          <Typography className="create-journey-title">
            {t('create_journey_page.title')}
          </Typography>
        </Box>
        <Box className="create-journey-steps-container">
          <Box className="create-journey-step-container">
            <Box className="create-journey-progress-container">
              <Box className="create-journey-light-icon-container">
                <Box className="create-journey-icon-container">
                  <BadgeOutlinedIcon className="create-journey-icon" />
                </Box>
              </Box>
              <Box className="create-journey-progress-bar">
                <Box className="create-journey-progress" />
              </Box>
            </Box>
            <Typography className="create-journey-text">
              {t('create_journey_page.step_identity')}
            </Typography>
          </Box>
          <Box className="create-journey-step-container">
            <Box className="create-journey-progress-container">
              <Box className="create-journey-light-icon-container-empty">
                <Box className="create-journey-icon-container-empty">
                  <Diversity1Icon className="create-journey-icon" />
                </Box>
              </Box>
            </Box>
            <Typography className="create-journey-text">
              {t('create_journey_page.step_add_your_family')}
            </Typography>
          </Box>
        </Box>

        <Box className="create-journey-testimonial-container">
          <Typography className="create-journey-testimonial">
            {t('create_journey_page.testimonial_1')}{' '}
            <span className="create-journey-testimonial create-journey-testimonial-bold">
              {t('create_journey_page.testimonial_2')}
            </span>
          </Typography>
          <Typography className="create-journey-testimonial">
            {t('create_journey_page.testimonial_3')}
          </Typography>
        </Box>
        <Box className="create-journey-brands-container">
          <img
            src={IMAGES.VISA.src}
            width={IMAGES.VISA.width}
            height={IMAGES.VISA.height}
          />
          <img
            src={IMAGES.SUPPORT.src}
            width={IMAGES.SUPPORT.width}
            height={IMAGES.SUPPORT.height}
          />
          <img
            src={IMAGES.APP_RATING.src}
            width={IMAGES.APP_RATING.width}
            height={IMAGES.APP_RATING.height}
          />
        </Box>
        <ButtonContainer sticky>
          <AppButton
            id="create-journey-continue-to-verification-button"
            onClick={() => {
              trackSelectOnboardingKidFinancialLiteracy();
              navigate('/onboarding/kyc');
            }}
            label={t('create_journey_page.verification_button')}
          />
        </ButtonContainer>
        <Box className="create-journey-disclaimer-container">
          <Typography className="create-journey-disclaimer">
            {t('create_journey_page.disclaimer_1')}
          </Typography>
          <Typography
            component="div"
            className="create-journey-disclaimer">
            {t('create_journey_page.disclaimer_5')}{' '}
            <Typography className="create-journey-disclaimer">
              {t('create_journey_page.disclaimer_6')}
              <a
                href={LINKS.CONSUMER_ACCOUNT_CARD_HOLDER_AGREEMENT}
                target="_blank"
                rel="noopener noreferrer"
                className="text-link">
                {t('create_journey_page.disclaimer_7')}
              </a>
            </Typography>
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

const CreateJourneyPage = () => (
  <ViewModelProvider>
    <CreateJourneyContent />
  </ViewModelProvider>
);

export default CreateJourneyPage;
